export const resetFileName = (file) => {
    const name = file?.name.toLowerCase();
    return new File([file], name, { type: file.type });
}